<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap">
                {{ getText(processConfig?.globalizationConfig, 'title') | uppercase }}
            </ion-label>
        </ion-item>

        <app-step-description [description]="getText( processConfig?.globalizationConfig, 'instructions' )"
        ></app-step-description>

        <ion-card mode="ios" class="team-card">
            <ion-card-header color="">
                <ion-searchbar
                        mode="ios"
                        class="section-search-custom"
                        [placeholder]="'generic.searchByName' | translate"
                        (keyup)="updateSearch($event.target.value)"
                ></ion-searchbar>
            </ion-card-header>
            <ion-card-content class="ion-no-padding">
                <app-evaluated-user-list
                        [cycleParticipantId]="cycleParticipantId"
                        [displayedUserEvaluations]="displayedUserEvaluations"
                        [processConfig]="processConfig"
                        [areas]="areas"
                        [cycleId]="_cycleId"
                        (getEvaluations)="resetGetEvaluations()">
                </app-evaluated-user-list>
            </ion-card-content>
        </ion-card>
        <div class="load-more">
            <ion-item lines="none" *ngIf="userEvaluations.length < allEvaluationsLength">
                <ion-button (click)="getEvaluations(userIndex, pageSize)">{{ 'generic.loadMore' | translate }}</ion-button>
            </ion-item>
        </div>
    </div>
</ion-content>
